/**
 * A {@link ComboboxUnlisted Combobox.Unlisted} is a compound
 * component for use with a {@link Combobox Combobox}, representing an option
 * that may be initially selected and can be removed, but is not visible in
 * the drop-down menu as a selectable option. If it is initially selected, it
 * will appear in italics.
 *
 * @returns {null} This component intentionally returns `null`. We
 * anticipate this component is used within a `<Combobox />`
 * which will pass its `children` to a hook which will iterate through the
 * children and convert each to a node. We do it this way so the
 * consuming API is using JSX.
 */
const ComboboxUnlisted = () => {
    return null;
};
export default ComboboxUnlisted;
//# sourceMappingURL=ComboboxUnlisted.js.map